// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"156649ad","1698":"18581021","2860":"5583c8ec","3734":"65b7c879","4242":"b4d07dad","4483":"7bae20aa","5431":"40d945be","8697":"65b7c879","9490":"07ea41ec"}[chunkId] + ".chunk.css";
};